import React, { useContext, useEffect, useRef, useState } from "react";
import Group from "../assets/images/Group.svg";
import chevron from "../assets/images/chevron-down.svg";
import globe from "../assets/images/globe-01.svg";
import { AppContext } from "../contaxt/AppContext";
import DropdownLanguage from "../pages/multiLang/DropDown";
import { useTranslation } from "react-i18next";
import { Accordion, Dropdown, Tooltip } from "react-bootstrap";
import { changeLanguage, t } from "i18next";
import dropdown from "../assets/images/arrow-drop-down-svgrepo-com.svg";
import dropup from "../assets/images/arrow-drop-up-svgrepo-com.svg";
import clockTime from "../assets/images/clockGrey.svg";
import { simpleGetCall } from "../api/ApiServices";
import { lungueges } from "../constant/lungueges";
import MyCountdownTimer from "./timer";
import { useSelector } from "react-redux";



const McqHeader = ({ props }) => {
    const [show, setShow] = useState(true);

    const prevScrollY = useRef(0);


    console.log(props);
    const { percentage, setPercentage, ChangeLang } = useContext(AppContext);
    const [showDropDown, setShowDropDown] = useState(false);
    const [quizCompletPercenteg, setQuizComltPercentage] = useState(0)
    const roundData = useSelector((state => state.roundData))

    const [comapnyName, setCompanyName] = useState("");
    const [percentage1, setPercentage1] = useState();
    // let [company, setcompany] = useState();
    console.log(percentage1, "percentage1");
    const [isOpen, setIsOpen] = useState(false);
    // let [company,setcompany]=useState();
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const dropdownRef1 = useRef(null);
    const dropdownRef2 = useRef(null);

    const handleClickOutside = (event) => {
        if (
            dropdownRef1.current &&
            !dropdownRef1.current.contains(event.target) &&
            dropdownRef2.current &&
            !dropdownRef2.current.contains(event.target)
        ) {
            setShowDropDown(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDropDown = () => {
        setShowDropDown(!showDropDown);
        setIsOpen(!isOpen);
    };
    console.log(roundData);
    
    const languages = [
        { name: "English" },
        { name: "Hindi" },
        { name: "Telugu" },
    ];

    const getLang = () => {
        simpleGetCall().then((res) => { });
    };

    useEffect(() => {
        const progressBar = document.getElementById("progressBar");
        let percentage = (roundData?.count / roundData?.questions?.length) * 100
        setQuizComltPercentage(percentage.toFixed(0) || 0)
        progressBar.style.width = percentage + "%";
    }, [roundData?.count]);

    useEffect(() => {
        const storedPercentage = localStorage.getItem("percentage");

        console.log(storedPercentage, "storeeeeeee");
        //setPercentage(storedPercentage);
        if (storedPercentage) {
        }
        console.log(percentage1);
    }, [percentage1]);

    const [curr, setCurr] = useState({
        en: "English",
        hi: "Hindi",
        te: "Telugu",
    });

    const handleLangChange = (lang) => {
        localStorage.setItem("language", lang);
        setShowDropDown(false);
    };
    const [currentLanguage, setCurrentLunguege] = useState(
        localStorage.getItem("language")
    );

    return (
        <>
            <div className="container-fluid Header-main " id="Header-main">
                <div className="row justify-content-between height-adj">
                    <div className="col-auto d-flex align-items-center">
                        <div className="border-imgHead-r mt-1">
                            <a href="/">
                                <img src={Group} className="GroupImg" alt="Group" />
                            </a>
                        </div>
                        <div className="d-flex flex-column ms-3 mt-2">
                            <div>
                                {/* <h2>Answer Following MCQ's</h2> */}
                                <h2>Short Quiz {roundData?.position} - {roundData?.companyname}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-auto d-flex align-items-center pe-4">
                        <div className="row align-items-center">
                            <div className="percentage-col col d-flex mt-2 align-items-center justify-content-center">
                                <h5 className="text-center pertxt ">{quizCompletPercenteg || 0}% </h5>
                                <span className="completed-text pb-2">Completed</span>
                            </div>
                            <div className="col mt-2 justify-content-center d-flex align-items-center pb-1">
                                <div className="progress">
                                    <div
                                        id="progressBar"
                                        className="progress-bar"
                                        style={{
                                            width: quizCompletPercenteg + "%",
                                            backgroundColor: "#4C60E5",
                                            borderRadius: "4px",
                                            height: "8px",
                                        }}
                                    ></div>
                                </div>
                            </div>
                            <div className="col">
                                <div
                                    className="d-flex flex-column postion-relative"
                                >
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ cursor: "pointer",padding:'5px',border:roundData?.duration<1?"1px solid #FECACA":'1px solid rgb(208, 213, 221)',borderRadius:'5px',backgroundColor:roundData?.duration<1?'#FEF2F2':"" }}
                                    >
                                        
                                        <img
                                            src={clockTime}
                                            alt="Clock Icon"
                                            className=""
                                            style={{ width: "20px", height: "20px", marginRight: "5px",
                                                  filter: roundData?.duration < 1
      ? "invert(16%) sepia(95%) saturate(6932%) hue-rotate(359deg) brightness(97%) contrast(89%)"
      : "none"
                                             }}
                                        />
                                        <p className="me-2 timerTxt">
                                            <MyCountdownTimer />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`d-flex justify-content-center position-absolute ${show ? "place-below-header" : "show-above"
                    }`}
            >
                {/* <button className="border-0 p-0" onClick={handleShowShutter}>
          {show ? (
            <img className="drop-img" src={dropup} />
          ) : (
            <img className="drop-img" src={dropdown} />
          )}
        </button> */}
            </div>
            {show && (
                <div
                    className={`container-fluid Header-mainmbl-mcq ${show ? "showanimate" : "notshowanimate"
                        } `}
                    id="Header-main"
                >
                    <div className="col-12">
                        <div className="row justify-content-between">
                            <div className="col-9 col-lg-6 d-flex align-items-center ">
                                <div className="ms-3">
                                    <div>
                                        {/* <h2>Answer Following MCQ's</h2> */}
                                        <h2>Short Quiz {roundData?.position} - {roundData?.companyname}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 col-lg-6 d-flex align-items-center justify-content-end">
                                <div className="row ">
                                    <div className="col">
                                        <div
                                            className="d-flex flex-column postion-relative"
                                        >
                                            <div
                                                className="d-flex align-items-center mb-2"
                                               

                                        style={{ cursor: "pointer",padding:'5px',border:roundData?.duration<1?"1px solid #FECACA":'1px solid rgb(208, 213, 221)',borderRadius:'5px',backgroundColor:roundData?.duration<1?'#FEF2F2':"" }}
                                            >

                                                <img
                                                    src={clockTime}
                                                    alt="Clock Icon"
                                                    className=""
                                                    style={{ width: "20px", height: "20px", marginRight: "5px",
                                                                                            filter: roundData?.duration < 1
      ? "invert(16%) sepia(95%) saturate(6932%) hue-rotate(359deg) brightness(97%) contrast(89%)"
      : "none"
                                                     }}
                                                />
                                                <p className="me-2 timerTxt">
                                                    <MyCountdownTimer />                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default McqHeader;
